import {recordSchema} from '@lightweightform/storage';
import {nonUnionormSchema} from './non-union-form/non-union-form.schema';

/**
 * App schema.
 */
export const appSchema = recordSchema({
  'non-union-form': nonUnionormSchema
});
